var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.9993 3.33301H9.99935C9.11529 3.33301 8.26745 3.6842 7.64233 4.30932C7.0172 4.93444 6.66602 5.78229 6.66602 6.66634V33.333C6.66602 34.2171 7.0172 35.0649 7.64233 35.69C8.26745 36.3152 9.11529 36.6663 9.99935 36.6663H29.9993C30.8834 36.6663 31.7312 36.3152 32.3564 35.69C32.9815 35.0649 33.3327 34.2171 33.3327 33.333V11.6663L24.9993 3.33301Z",
    stroke: "#E7000B",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.334 3.33301V9.99967C23.334 10.8837 23.6852 11.7316 24.3103 12.3567C24.9354 12.9818 25.7833 13.333 26.6673 13.333H33.334",
    stroke: "#E7000B",
    strokeWidth: 2.08333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/pdf-icon.d2ff9dfd43c02a395657515301e63f80.svg";
export { ForwardRef as ReactComponent };